"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRecommendedItemsList = exports.getRecommendedProductsList = void 0;
const reco_strip_utils_1 = require("../reco-strip.utils");
const queries_1 = require("./queries");
const utils_1 = require("../utils");
const getRecommendedProductsList = async (apiRoutes, prismicRef, list) => {
    try {
        const query = queries_1.GET_RECOMMENDED_PRODUCTS_LIST;
        const variables = {
            list
        };
        const { getRecommendationData } = await (0, reco_strip_utils_1.api)(apiRoutes.content, {
            query,
            variables,
            prismicRef
        });
        if (!getRecommendationData || !getRecommendationData.recommendedItems.length) {
            throw new Error(`No recommended products were returned for key ${list}`);
        }
        return getRecommendationData;
    }
    catch (error) {
        console.error(`[Content: getRecommendedProductsList]: Error fetching recommended products with error message: ${error.message}`);
        return [];
    }
};
exports.getRecommendedProductsList = getRecommendedProductsList;
const getRecommendedItemsList = async (apiRoutes, recommendedItems) => {
    const productCodes = recommendedItems.map((item) => item.sku);
    try {
        const query = queries_1.GET_RECOMMENDED_PRODUCTS;
        const variables = {
            productCodes
        };
        const { products } = await (0, reco_strip_utils_1.api)(apiRoutes.catalog, { query, variables });
        const recommendedItemsList = recommendedItems
            .reduce((acc, product) => {
            const catalogProduct = products.find(({ productCode }) => product.sku === productCode);
            // Skip unactive products
            if (!product.isActiveInRecommendedProducts) {
                return acc;
            }
            // Check if all variants of the product are out of stock
            const isOutOfStock = catalogProduct &&
                catalogProduct.variants.every((variant) => variant.inStock === false);
            // Out of the stock products will be filtered out from the list
            if (isOutOfStock) {
                return acc;
            }
            // Enrich product with catalog data + build image URL
            if (catalogProduct && product.ardadDescriptors.length > 0 && catalogProduct.defaultVariant) {
                const { defaultImage } = (0, utils_1.getDetailTileArdadImages)(product.ardadDescriptors, catalogProduct.defaultVariant, '4-3');
                product.defaultImage = defaultImage;
                acc.push({ ...product, ...catalogProduct });
            }
            return acc;
        }, []);
        return recommendedItemsList;
    }
    catch (error) {
        const errorMessage = `Error fetching recommended product list with data: productCodes: ${JSON.stringify(productCodes)}`;
        console.error(`[Catalog: getRecommendedItemsList]: ${errorMessage}`);
        return [];
    }
};
exports.getRecommendedItemsList = getRecommendedItemsList;
//# sourceMappingURL=actions.js.map